import React, { useState, useRef, useEffect } from 'react';
import TreeDiv from '../AddressTree/AddressTree';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/ru';
import s from "./Reports.module.css"
import { Link } from 'react-router-dom';
import { ReportChoiceData, DateCalendarViews } from './ReportUtils';
import ReportButtons from '../ButtonsGroup/ReportButtons';
import { formatDateUnix } from '../../utils/date';
import { useUser } from '../../Context/UserContext';
import CircularProgress from "@mui/material/CircularProgress";
import { exportBalanceToExcel, exportToExel, exportErip, fetchReportsList } from '../../Api//ReportsApi'


dayjs.extend(utc);
dayjs.extend(timezone);


function Reports({ handleLogsClick }) {
    const { user } = useUser();

    const [devicesList, setDevice] = useState([])
    const [startDate, setStartDate] = useState(dayjs().startOf('month'));
    const [endDate, setEndDate] = useState(dayjs().endOf('month'));

    const [aggregateData, setAggregateData] = useState('current');
    const [searchQuery, setSearchQuery] = useState('');
    const [searchAddressQuery, setSearchAddressQuery] = useState('');
    const [fullAddress, setFullAddress] = useState([]);

    const [openTree, setOpenTree] = useState(false)
    const popupRef = useRef(null);
    const buttonRef = useRef(null);
    const [loading, setLoading] = useState(false);

    const [total, setTotal] = useState(null)
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemPerPage] = useState(10);

    const [sortOrder, setSortOrder] = useState({});
    const [order, setOrder] = useState('')

    const tableProps = {
        devicesList,
        setDevice,
        startDate,
        setStartDate,
        endDate,
        setEndDate,
        total,
        currentPage,
        setCurrentPage,
        itemsPerPage,
        setItemPerPage,
        sortOrder,
        setSortOrder,
        order,
        setOrder,
        aggregateData,
        setAggregateData,
        handleLogsClick,
        fullAddress,
        searchQuery,
        user,
        loading
    }

    useEffect(() => {
        if (startDate && endDate) {
            async function fetchDevice() {
                setLoading(true);
                try {

                    const startDateISO = startDate.tz('Europe/Minsk').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
                    let endDateISO;
                    if (aggregateData === 'current') {
                        endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
                    } else if (aggregateData === 'startOfDay') {
                        endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
                    } else if (aggregateData === 'startOfMonth') {
                        endDateISO = endDate.tz('Europe/Minsk').endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS')
                    } else if (aggregateData === 'startOfYear') {
                        endDateISO = endDate.tz('Europe/Minsk').endOf('year').format('YYYY-MM-DDTHH:mm:ss.SSS')
                    } else {
                        endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
                    }

                    const fetchProps = {
                        itemsPerPage,
                        currentPage,
                        fullAddress,
                        searchQuery,
                        order,
                        aggregateData,
                        startDateISO,
                        endDateISO,
                    }

                    const data = await fetchReportsList(fetchProps);

                    const { devices } = data
                    const { total } = data
                    const result = devices.flatMap(item =>
                        item.result.map(result => ({ ...result, device: item }))
                    );

                    setDevice(result);
                    setTotal(total);
                } catch (error) {
                    console.error('Error fetching logs:', error);
                } finally {
                    setLoading(false);
                }
            }
            fetchDevice();
        }
    }, [startDate, endDate, currentPage, itemsPerPage, fullAddress, searchQuery, order]);


    const getInitialDates = (type) => {
        switch (type) {
            case 'current': return { start: dayjs().startOf('month'), end: dayjs().endOf('month') };
            case 'startOfDay': return { start: dayjs(), end: dayjs() };
            case 'startOfMonth': return { start: dayjs().startOf('month'), end: dayjs().endOf('month') };
            case 'startOfYear': return { start: dayjs().startOf('year'), end: dayjs().endOf('year') };
            default: return { start: dayjs().startOf('month'), end: dayjs().endOf('month') };
        }
    };

    useEffect(() => {
        const { start, end } = getInitialDates(aggregateData);
        setStartDate(start);
        setEndDate(end);
    }, [aggregateData]);

    const handleFullAddressChange = (address) => {
        if (JSON.stringify(fullAddress) !== JSON.stringify(address)) {
            setFullAddress(address);
        }
    };


    const handleItemClick = (event) => {
        event.stopPropagation();
        setOpenTree(true);
    };

    const cancelClick = () => {
        setFullAddress([]);
        setDevice([]);

    }

    const handleClickOutside = (event) => {
        if (
            popupRef.current && !popupRef.current.contains(event.target) &&
            buttonRef.current && !buttonRef.current.contains(event.target)
        ) {
            setOpenTree(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <div className={s.main}>
            <div className={s.searchFrame}>
                <input
                    type='text'
                    className={s.search}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    placeholder='Поиск по imei, devEUI или номеру'
                >
                </input>
                <img src={'/search.svg'}></img>
            </div>

            <div className={s.addressWarp}>
                <div className={s.addressFrame} onClick={handleItemClick} ref={buttonRef}>
                    <div className={s.frame75} >
                        <div className={s.frame75logo}>
                            <img src={'/home.svg'}></img>
                        </div>
                        <div className={s.frame75Text}>Список адресов</div>
                        <div className={s.arrowDown}>
                            <img src={'/arrowback.svg'}></img>

                        </div>
                    </div>

                    {openTree && (
                        <div className={s.addressPopup} ref={popupRef}>
                            <div className={s.address}>
                                <div className={s.addressInput}>
                                    <input
                                        type='text'
                                        className={s.addressSearch}
                                        value={searchAddressQuery}
                                        onChange={(e) => setSearchAddressQuery(e.target.value)}
                                        placeholder='Поиск адреса'
                                    >
                                    </input>
                                    <img src={'/search.svg'}></img>
                                </div>
                                <div>
                                    <TreeDiv setSelectedAddress={(address) => {
                                        setSelectedAddress(address);
                                    }} handleFullAddressChange={handleFullAddressChange} />
                                </div>
                            </div>
                        </div>
                    )}
                </div>

                {fullAddress.length > 0 && (
                    <div className={s.chosedAddr} onClick={cancelClick} >
                        <div className={s.chosedAddrImg}>
                            <img
                                src={'/cancel.svg'}
                                alt="cancel"
                            />
                        </div>

                        <div className={s.chosedAddrText}>
                            {fullAddress.join(', ')}
                        </div>

                    </div>
                )}
            </div>

            <div className={s.wrapper}>

                <Table {...tableProps} />
            </div>
        </div>

    )
}
export default Reports;


const Table = (tableProps) => {
    const headers = ['Заводской номер', 'Адрес', 'Тип', 'Показание на конец выбранного периода', 'Потребление за выбранный период', 'Дата последней передачи', 'Детали'];
    const { devicesList, startDate, setStartDate,
        endDate, setEndDate, total, currentPage,
        setCurrentPage, itemsPerPage, setItemPerPage, user,
        sortOrder, setSortOrder, order, setOrder, fullAddress, searchQuery,
        aggregateData, setAggregateData, handleLogsClick, loading } = tableProps

    const handleExportXLSX = () => {

        const startDateISO = startDate.tz('Europe/Minsk').format('YYYY-MM-DDTHH:mm:ss.SSS')
        let endDateISO;
        if (aggregateData === 'current') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (aggregateData === 'startOfDay') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (aggregateData === 'startOfMonth') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (aggregateData === 'startOfYear') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('year').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else {
            endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        }

        const dataToExport = {
            aggregateData,
            startDateISO,
            endDateISO,
            fullAddress,
            searchQuery,
            order,
            user
        };
        exportToExel({ dataToExport })
            .then(() => {
                console.log('Данные успешно отправлены для отчета за период');
            })
            .catch(error => {
                console.error('Ошибка отправки данных для отчета за период:', error);
            });
    };

    const handleBalanceExportXLSX = () => {

        const startDateISO = startDate.tz('Europe/Minsk').format('YYYY-MM-DDTHH:mm:ss.SSS')
        let endDateISO;
        if (aggregateData === 'current') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (aggregateData === 'startOfDay') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (aggregateData === 'startOfMonth') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (aggregateData === 'startOfYear') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('year').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else {
            endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        }


        const dataToExport = {
            startDateISO,
            endDateISO,
            fullAddress,
        };
        exportBalanceToExcel({ dataToExport })
            .then(() => {
                console.log('Данные успешно отправлены для отчета за период');
            })
            .catch(error => {
                console.error('Ошибка отправки данных для отчета за период:', error);
            });
    };

    const headerKeys = {
        'Заводской номер': 'dev_number',
        'Адрес': 'address',
    };


    const sortData = (field) => {
        const newSortOrder = sortOrder[field] === 1 ? -1 : 1;

        setSortOrder({
            ...sortOrder,
            [field]: newSortOrder
        });

        const orderField = newSortOrder === 1 ? field : `-${field}`;
        setOrder(orderField);
    };

    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(total / itemsPerPage); i++) {
        pageNumbers.push(i);
    }

    const totalPages = Math.ceil(total / itemsPerPage);

    const handleExportCSV = () => {
         const startDateISO = startDate.tz('Europe/Minsk').format('YYYY-MM-DDTHH:mm:ss.SSS')
        let endDateISO;
        if (aggregateData === 'current') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (aggregateData === 'startOfDay') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (aggregateData === 'startOfMonth') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else if (aggregateData === 'startOfYear') {
            endDateISO = endDate.tz('Europe/Minsk').endOf('year').format('YYYY-MM-DDTHH:mm:ss.SSS')
        } else {
            endDateISO = endDate.tz('Europe/Minsk').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS')
        }

        const dataToExport = {
            aggregateData,
            startDateISO,
            endDateISO,
            fullAddress,
            searchQuery,
            order,
            user
        };

        
        exportErip({ dataToExport })
            .then(() => {
                console.log('Данные успешно отправлены для отчета за период');
            })
            .catch(error => {
                console.error('Ошибка отправки данных для отчета за период:', error);
            });
    };



    const handlePreviousPage = () => {
        setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
    };

    const handleNextPage = () => {
        if (totalPages > 1) {
            setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
        }
    };

    const handleItemsPerPageChange = (event) => {
        setItemPerPage(Number(event.target.value));
        setCurrentPage(1);
    };


    const renderItems = devicesList.map((result, index) => (
        <tr key={`${index}`}>
            {headers.map((header) => (
                <td key={header} >
                    <div className={s.tableBodyText}>
                        {header === 'Детали' ? (
                            <Link to={`/device/${result.device._id}`} id={`${result.device.device.dev_number}`}>
                                <img src={'/document.svg'} />
                            </Link>
                        ) : header === 'Тип' ? (

                            result.device.device.dev_type === "ВС" && result.device.device.resourse_type === "Горячая вода" ? "ГВС"
                                : result.device.device.dev_type === "ВС" && result.device.device.resourse_type === "Холодная вода" ? "ХВС"
                                    : result.device.device.dev_type === "ТС" ? "ТС"
                                        : result.device.device.dev_type === "ЭС" ? "ЭС"
                                            : "ВС"

                        )
                            : header === 'Заводской номер' ? (
                                result.device.device.dev_number
                            ) : header === 'Адрес' ? (
                                `${result.device.address[0].city ? result.device.address[0].city + ', ' : ''}` +
                                `${result.device.address[0].street ? result.device.address[0].street + ', ' : ''}` +
                                `${result.device.address[0].building ? result.device.address[0].building + (result.device.address_number !== null ? ', ' : '') : ''}` +
                                `${result.device.address_number !== null && result.device.address_number !== undefined ? result.device.address_number : ''}`
                            ) : header === 'Показание на конец выбранного периода' ? (
                                `${(parseFloat(result.device_frmpayload_data_volume + result.device.data.start_volume) * (result.device.device.factor)).toFixed(3)} 
                                ${result.device.device.dev_type === 'ВС' ? 'м³'
                                    : result.device.device.dev_type === 'ТС' ? 'ГДж'
                                        : result.device.device.dev_type === 'ГС' ? 'м³'
                                            : 'кВт-Ч'}`
                            ) : header === 'Потребление за выбранный период' ? (
                                `${(parseFloat(result.device_frmpayload_data_volume_diff ?? 0) * (result.device.device.factor)).toFixed(3)} 
                                ${result.device.device.dev_type === 'ВС' ? 'м³'
                                    : result.device.device.dev_type === 'ТС' ? 'ГДж'
                                        : result.device.device.dev_type === 'ГС' ? 'м³'
                                            : 'кВт-Ч'}`
                            ) : header === 'Дата последней передачи' ? (

                                result.device_frmpayload_data_timestamp !== 0
                                    ? formatDateUnix(result.device_frmpayload_data_timestamp)
                                    : result.device.data.last_date_time !== 0
                                        ? formatDateUnix(result.device.data.last_date_time)
                                        : 'нет данных'

                            )
                                : (
                                    result[header]
                                )}
                    </div>
                </td>
            ))}
        </tr>
    ))


    return (
        <>
            <ReportButtons handleExportCSV={handleExportCSV} handleExportXLSX={handleExportXLSX} handleBalance={handleBalanceExportXLSX} handleLogsClick={handleLogsClick} />
            <div className={s.tableContainer}>
                <div className={s.warp}>
                    <ReportChoiceData aggregateData={aggregateData} setAggregateData={setAggregateData} />
                    <DateCalendarViews startDate={startDate} endDate={endDate} setStartDate={setStartDate} setEndDate={setEndDate} aggregateData={aggregateData} />
                    <div className={s.table}>

                        <div className={s.tableHeader}>
                            <table>
                                <thead>
                                    <tr>
                                        {headers.map((header) => (
                                            <th key={header} onClick={() => headerKeys[header] && sortData(headerKeys[header])}>
                                                <div className={s.warps}>
                                                    <div className={s.frame48Text}>{header}</div>
                                                    {header === 'Заводской номер' || header === 'Адрес' ? (
                                                        <div className={s.tableArrowDown}>

                                                            <img
                                                                src={sortOrder[headerKeys[header]] === 1 ? '/tablearrowup.svg' : '/tablearrowdown.svg'}
                                                                alt="sort"
                                                            />
                                                        </div>) : (null)}
                                                </div>
                                            </th>
                                        ))}
                                    </tr>
                                </thead>
                            </table>
                        </div>
                        <div className={s.tableBody}>
                            <table>
                                <tbody>
                                    {loading && (
                                        <div style={{ textAlign: "center" }}>
                                            <CircularProgress />
                                        </div>
                                    )}
                                    <>{renderItems}</>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className={s.paginate}>
                        <div className={s.paginateText}>{total} всего</div>
                        <div className={s.devicePerPage}>
                            <div className={s.devicePerPageText}>Показать</div>
                            <select className={s.inputPerPage} value={itemsPerPage} onChange={handleItemsPerPageChange}>
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                        </div>
                        <div className={s.paginateInput}>
                            <div className={s.arrowLeft} onClick={handlePreviousPage}>
                                <img src={'/arrowleft.svg'}></img>
                            </div>
                            <div className={s.page}>{currentPage}</div>
                            <div className={s.arrowRight} onClick={handleNextPage}>
                                <img src={'/arrowright.svg'}></img>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

